/* eslint-disable @typescript-eslint/no-explicit-any */
import VehicleDashboardTable from "./VehicleDashboardTable";
import { useContext, useState } from "react";
import { Button, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { VehicleDashboardTableType } from "../Utils/autocompleteEnum";
import { Vocabulary } from "../Utils/Vocabulary";
import { urlEnum } from "../Utils/urlEnum";
import { VehicleContext } from "../Context/vehicleContext";
import {
  europeanDate,
  formatNumber,
  usDateFormatWithTime,
} from "../Utils/formatDate";
import moment from "moment";

export default function VehicleService() {
  const vehicleContext: any = useContext(VehicleContext);
  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selected, setSelected]: any = useState(null);

  const emptyFields = () => {
    setSelected(null);
  };

  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: true,
        sort: true,
      },
    },

    {
      name: "data_intrare",
      label: "Data intrare service",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (date: any) => (
          <>
            {date
              ? moment(date, usDateFormatWithTime).format(europeanDate)
              : ""}
          </>
        ),
      },
    },
    {
      name: "data_iesire",
      label: "Data iesire service",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (date: any) => (
          <>
            {date
              ? moment(date, usDateFormatWithTime).format(europeanDate)
              : ""}
          </>
        ),
      },
    },
    {
      name: "mentiuni",
      label: "Mentiuni",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "cost",
      label: "Cost",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (cost: string) => (
          <Typography>{formatNumber(cost)} Lei</Typography>
        ),
      },
    },
    {
      name: "file",
      label: "file",
      options: {
        filter: true,
        sort: false,
        display: false,
      },
    },

    {
      name: "fileName",
      label: " ",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (fileName: any) => {
          if (fileName === null) return null;
          const path = `${urlEnum.vehicles}/${fileName}`;
          return (
            <Button
              style={{ float: "right" }}
              size="small"
              color="primary"
              variant="contained"
              data-file={path}
            >
              {Vocabulary.open}
            </Button>
          );
        },
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (rowIndex: number) => (
          <div style={{ float: "right" }}>
            <EditIcon
              style={{
                marginRight: 15,
                height: 30,
                cursor: "pointer",
                color: "#4449",
              }}
              onClick={(event: any) => {
                event.stopPropagation();
                setSelected(
                  vehicleContext?.state?.vehicle?.interventii_service[rowIndex]
                );
                setOpenEditModal(true);
              }}
            ></EditIcon>
            <DeleteIcon
              style={{ height: 30, cursor: "pointer", color: "#4449" }}
              onClick={(event: any) => {
                event.stopPropagation();
                setSelected(
                  vehicleContext?.state?.vehicle?.interventii_service[rowIndex]
                );
                setOpenModal(true);
              }}
            ></DeleteIcon>
          </div>
        ),
      },
    },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "100%",
            margin: 10,
            overflowY: "auto",
          }}
        >
          <VehicleDashboardTable
            title={Vocabulary.service}
            data={vehicleContext?.state?.vehicle?.interventii_service}
            columns={columns}
            type={VehicleDashboardTableType.service}
            editData={selected}
            openEditModal={openEditModal}
            closeModal={() => {
              setOpenEditModal(false);
              setSelected(null);
            }}
            emptyFields={emptyFields}
            openModalDelete={openModal}
            closeModalDelete={() => {
              setSelected(null);
              setOpenModal(false);
            }}
          />
        </div>
      </div>
    </div>
  );
}
